import { render } from "./BlogsTable.vue?vue&type=template&id=5b409efa"
import script from "./BlogsTable.vue?vue&type=script&lang=js"
export * from "./BlogsTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__